import { NumericalColumn, StringColumn, BooleanColumn } from 'baseui/data-table';
import { CustomDateColumn, EMPTY_STRING } from 'commons-ui';

export const COL_NAMES = {
	versionNumber: 'versionNumber',
	controlVersionNumber: 'controlVersionNumber',
	testPercentage: 'testPercentage',
	isActive: 'isActive',
	deployedAt: 'deployedAt',
	deployedBy: 'deployedBy',
	createdAt: 'createdAt',
	websiteName: 'websiteName'
};

export const columnConfigs = [
	StringColumn({
		title: 'Website',
		mapDataToValue: (data: any) => data[COL_NAMES.websiteName]
	}),
	NumericalColumn({
		title: 'Test Version Number',
		mapDataToValue: (data: any) => data[COL_NAMES.versionNumber]
	}),
	NumericalColumn({
		title: 'Control Version Number',
		mapDataToValue: (data: any) => data[COL_NAMES.controlVersionNumber]
	}),
	NumericalColumn({
		title: 'Test Percentage',
		mapDataToValue: (data: any) => data[COL_NAMES.testPercentage]
	}),
	StringColumn({
		title: 'Deployed By',
		mapDataToValue: (data: any) => data[COL_NAMES.deployedBy] || EMPTY_STRING
	}),
	BooleanColumn({
		title: 'Is Active',
		mapDataToValue: (data: any) => data[COL_NAMES.isActive]
	}),
	CustomDateColumn({
		title: 'Deployed At',
		minWidth: 150,
		maxWidth: 200,
		columnName: COL_NAMES.deployedAt
	}),
	CustomDateColumn({
		title: 'Created At',
		minWidth: 150,
		maxWidth: 200,
		columnName: COL_NAMES.createdAt
	})
];
